import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DealsDataGrid from '../../../Deals/Page/DealsDataGrid'
import { MemberStatus } from '../../../../utils/enums';
import useApiManager from '../../../../utils/Api/apiManager';

const DealsDialog = ({ open, setOpen, campaignId, fetchDeals, fetchCampaignRelatedEntitiesCount }) => {
    const [selectedRows, setSelectedRows] = useState(null); // State to store selected row ID
    const { put } = useApiManager();
    const [memberStatus, setMemberStatus] = useState(0);

    const handleClose = () => {
        setOpen(false);
    };

    // Handler to capture selected row ID
    const handleSelectionChange = (newSelection) => {
        setSelectedRows(newSelection); // Store selected row IDs
    };

    const handleAddDeal = async () => {
        if (selectedRows < 1) {
            alert("Please select a row!");
            return;
        }
        try {
            const responseData = await put(`/campaigns/${campaignId}/deals/assign`, {
                dealIds: selectedRows
            });
            // console.log('Form Submitted Successfully:', responseData);
            handleClose();
            fetchDeals();
            fetchCampaignRelatedEntitiesCount();

            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };
    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Choose Deal</DialogTitle>
            <DialogContent>
                <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
                    <DealsDataGrid
                        onSelectionModelChange={handleSelectionChange}
                        unassigned={true} />

                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                <Button onClick={handleAddDeal}>Add Deal</Button>
            </DialogActions>
        </Dialog>
    )
};

export default DealsDialog;